<template>
	<select>
		<slot></slot>
	</select>
</template>

<script>

import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import feedbackMixin from "../mixins/feedback"
import select2 from 'select2'

Vue.use(VueAxios, axios)

export default {
	name: "Select2",
	props: ['value'],
	mixins: [feedbackMixin],
	mounted: function () {
		let vm = this
		$(this.$el)
			// init select2
			.select2({data: this.options})
			.val(this.value)
			.trigger('change')
			// emit event on change.
			.on('change', function () {
				let selectedData = $(vm.$el).select2('data')
				if (selectedData.length > 0) {
					vm.$emit('input', selectedData[0].id)
				}
			})
	},
	watch: {
		value: function (value) {
			// update value
			$(this.$el)
				.val(value)
				.trigger('change')
		}
	},
	destroyed: function () {
		$(this.$el).off().select2('destroy')
	}
}
</script>

<style>
.select2 {
    width: 100% !important;
}
</style>